export class AprovadorSLD {
  constructor(public login: string, public nome: string) { }
}

export interface IAprovadorSLDResponse {
  total: number;
  data: AprovadorSLD[];
}

